/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['backbone'], function(backbone) {
    var ORIENTATION_ANY = 'any';
    var ORIENTATION_HORIZONTAL = 'horizontal';
    var ORIENTATION_VERTICAL = 'vertical';

    return backbone.Model.extend(
        {
            defaults: {
                product: null,

                /**
                 * @var string
                 */
                orientation: ORIENTATION_ANY,
                templates: [],
                page: 1,
                limit: 0,
                total: 0,
                searchContext: null,
                galleryLoading: true,
                templatesLoading: false
            },

            initialize: function(options) {
                this.set('templates', new backbone.Collection());
            }
        },
        {
            ORIENTATION_ANY: ORIENTATION_ANY,
            ORIENTATION_HORIZONTAL: ORIENTATION_HORIZONTAL,
            ORIENTATION_VERTICAL: ORIENTATION_VERTICAL
        }
    );
});
